import apiRequest from "../../../apiRequest";
import { endPoints } from "../../../apis";

/**
 * Fetch drivers list.
 * @param {Object} options
 * @param {number} options.page
 * @param {number} options.total
 * @param {string} options.role
 * @param {string} options.search
 * @returns {Promise<any>}
 */
export const fetchDrivers = async ({ page = 1, total = 0, role = "driver", search = "" }) => {
  const params = { page, total, role, search };
  return apiRequest.get(endPoints.GET_DRIVERS, params);
};
export const fetchDriversPayout = async ({ status = "All" }) => {
  const params = { status };
  return apiRequest.get(endPoints.GET_DRIVER_PAYOUT, params);
};


export const updateDriverPayoutStatus = async ({ id, status }) => {
  return apiRequest.put(`${endPoints.UPDATE_DRIVER_PAYOUT_STATUS}/${id}`, { status });
}

export const getDriverStatus = async () => {
  return apiRequest.get(endPoints.GET_DRIVER_PAYOUT_STATUSES);
}

// DRIVER SETTLEMENT
export const fetchDriversSettlement = async ({ status = "All" }) => {
  const params = { status };
  return apiRequest.get(endPoints.GET_DRIVER_SETTLEMENT, params);
};
/**
 * Update driver status.
 * TODO: Replace STATUS_CATEGORY endpoint when driver status endpoint is available.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {"active"|"inactive"} options.status
 * @param {string} [options.token]
 * @returns {Promise<any>}
 */
export const updateDriverStatus = async ({ id, status, token }) => {
  const config = token
    ? {
      headers: {
        "x-access-token": token,
      },
    }
    : {};

  return apiRequest.put(`${endPoints.STATUS_CATEGORY}/${id}`, { status }, config);
};

/**
 * Delete driver.
 * TODO: Replace DELETE_CATEGORY endpoint when driver delete endpoint is available.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {string} [options.token]
 * @returns {Promise<any>}
 */
export const deleteDriver = async ({ id, token }) => {
  const config = token
    ? {
      headers: {
        "x-access-token": token,
      },
    }
    : {};

  return apiRequest.delete(`${endPoints.DELETE_CATEGORY}/${id}`, config);
};

/**
 * Fetch driver detail by id.
 * @param {number|string} id
 * @returns {Promise<any>}
 */
export const fetchDriverById = async (id) => {
  return apiRequest.get(`${endPoints.GET_SINGLE_DRIVER}/${id}`);
};

/**
 * Fetch driver orders by driver id.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {number} options.page
 * @param {number} options.total
 * @returns {Promise<any>}
 */
export const fetchDriverOrders = async ({ id, page = 1, total = 0 }) => {
  const params = { page, total };
  return apiRequest.get(`${endPoints.GET_DRIVERS_ORDERS}/${id}`, params);
};

/**
 * Fetch single order detail.
 * @param {number|string} orderId
 * @returns {Promise<any>}
 */
export const fetchOrderById = async (orderId) => {
  return apiRequest.get(`${endPoints.GET_SINGLE_ORDER}/${orderId}`);
};

export const fetchCoa = async () => {
  return apiRequest.get(`${endPoints.GET_COA}`);
};

export const createOrAddAmount = async (data) => {
  return apiRequest.post(`${endPoints.CREATE_OR_ADD_AMOUNT}`, data);
};

export const getWalletByUserId = async (id) => {
  return apiRequest.get(`${endPoints.GET_WALLET_BY_USER_ID}/${id}`);
};

/**
 * Fetch wallet transactions by wallet id.
 * @param {Object} options
 * @param {number|string} options.walletId
 * @param {number} [options.page=1]
 * @param {number} [options.total=100]
 * @returns {Promise<any>}
 */
export const getTransactionsByWalletId = async ({ walletId, page = 1, total = 100 }) => {
  const params = { page, total };
  return apiRequest.get(`${endPoints.GET_TRANSACTIONS_BY_WALLET_ID}/${walletId}`, params);
};
